import { useCallback, useState } from 'react';
import { storage } from './storage';

export type ThemePreference = 'system' | 'light' | 'dark';

const THEME_KEY = 'citilight-monitor:theme';

function readPreference(): ThemePreference {
  const saved = storage.get(THEME_KEY);
  return saved === 'light' || saved === 'dark' ? saved : 'system';
}

/** System / light / dark; stored per browser and applied as data-theme on <html>. */
export function useTheme(): [ThemePreference, (next: ThemePreference) => void] {
  const [preference, setPreference] = useState(readPreference);

  const update = useCallback((next: ThemePreference) => {
    if (next === 'system') {
      storage.remove(THEME_KEY);
      delete document.documentElement.dataset.theme;
    } else {
      storage.set(THEME_KEY, next);
      document.documentElement.dataset.theme = next;
    }
    setPreference(next);
  }, []);

  return [preference, update];
}
